export interface User {
  id: string;
  email: string;
  username: string;
  full_name?: string;
  is_active: boolean;
  created_at: string;
}

export interface Paper {
  id: string;
  title?: string;
  doi?: string;
  authors?: string;
  original_filename: string;
  file_size: number;
  mime_type: string;
  upload_status: string;
  created_at: string;
  // Aggregated audit status
  audit_status?: string;  // none, pending, running, completed, failed
  audit_risk_level?: string;  // green, yellow, orange, red, black
  audit_task_count: number;
}

export interface PaperListResponse {
  items: Paper[];
  total: number;
  page: number;
  page_size: number;
}

export interface AuditTask {
  id: string;
  task_type: string;
  status: string;
  overall_risk_level?: string;
  findings_count: number;
  high_findings: number;
  medium_findings: number;
  low_findings: number;
  paper_id: string;
  paper_title?: string;
  created_at: string;
  completed_at?: string;
}

// Task type display names
export const TASK_TYPE_LABELS: Record<string, string> = {
  full_audit: '完整审查',
  numeric_forensics: '数值取证',
  image_integrity: '图像完整性',
  citation_check: '引用检查',
  package_completeness: '包完整性',
  geng_numeric: 'Geng数值筛查',
  flow_plot: '流式图检测',
};

export interface Finding {
  detector: string;
  severity: 'low' | 'medium' | 'high';
  file: string;
  sheet?: string;
  location?: string;
  rule: string;
  evidence: string;
  false_positive_context?: string;
  raw_data_snapshot?: {
    type: string;
    columns?: string[];
    column?: string;
    sample_data: {
      row_indices: number[];
      values?: number[];
      differences?: (number | null)[];
      ratios?: (number | null)[];
      [key: string]: any;
    };
    statistics?: Record<string, any>;
  };
  image_evidence?: {
    label: string;
    path: string;
    filename: string;
  }[];
}

export interface AuditResult {
  overall_risk_level: string;
  findings_count: number;
  high_findings: number;
  medium_findings: number;
  low_findings: number;
  findings: Finding[];
  summary: string;
  recommendations: string[];
}

export interface LoginCredentials {
  username: string;
  password: string;
}

export interface RegisterData {
  email: string;
  username: string;
  password: string;
  full_name?: string;
}

export interface TokenResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
}
